import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const creatingIntegration = {
  popover: {
    title: 'Creating a New Integration',
    description:
      'Adding an integration is an easy way to connect your marketing automation platforms, CRM, and other third-party tools. This tour will guide you through setting up and managing these connections.'
  }
};
